<template>
  <div>
    <div class="component-title">
      <h1 class="">I would like to borrow</h1>
    </div>
    <div class="loan-container">
      <div class="loan-content-1 row flx align-items-center mb-20 mt-40">
        <div class="col-sm-5 col-md-5">Loan Amount Requested</div>
        <div class="col-sm-7 col-md-7 flx align-items-center">
          $<input type="type" name="" id="loanamount" class="input-common" @change="calculate_repayment"/>
        </div>
      </div>

      <div class="loan-content-1 row flx mb-20 align-items-center">
        <div class="col-sm-5 col-md-5">Loan Repayment Frequency</div>
        <div class="col-sm-7 col-md-7 flx align-items-center">
          <div class="toggle">
            <label>
              <input type="radio" name="loan_repayment_frequency" value="weekly" required="" @click="calculate_repayment"/>
              <div class="default" for="">Weekly</div>
            </label>
            <label>
              <input type="radio" name="loan_repayment_frequency" value="fortnightly" required="" @click="calculate_repayment"/>
              <div class="default" for="">Fortnightly</div>
            </label>
            <label>
              <input type="radio" name="loan_repayment_frequency" value="monthly" required="" @click="calculate_repayment"/>
              <div class="default" for="">Monthly</div>
            </label>
          </div>
        </div>
      </div>

      <div class="loan-content-1 row flx align-items-center mb-20">
        <div class="col-sm-5 col-md-5">Loan Term</div>
        <div class="col-sm-7 col-md-7 flx align-items-center">
          <label class="default col-sm-3 pl-0" for="">
            <input type="text" class="input-common" name="loan_term_input" value="" required=""/>
          </label>
          <div class="toggle">
            <label>
              <input type="radio" name="loan_term_period" value="months" required=""/>
              <div class="default">Months</div>
            </label>
            <label>
              <input type="radio" name="loan_term_period" value="years" required=""/>
              <div class="default">Years</div>
            </label>
          </div>
        </div>
      </div>

      <div class="loan-content-1 row flx align-items-center mb-20">
        <div class="col-sm-5 col-md-5">Case Term</div>
        <div class="col-sm-7 col-md-7 flx align-items-center">
          <label class="default col-sm-3 pl-0" for="">
            <input type="text" class="input-common" name="loan_term_input" value="" required=""/>
          </label>
          <div class="toggle">
            <label>
              <input type="radio" name="case_term_period" value="months" required=""/>
              <div class="default">Months</div>
            </label>
            <label>
              <input type="radio" name="case_term_period" value="years" required=""/>
              <div class="default">Years</div>
            </label>
          </div>
        </div>
      </div>

      <div class="oan-content-1 row flx align-items-center mb-20">
        <div class="col-sm-5 col-md-5">Estimated Repayment</div>
        <div class="col-sm-7 col-md-7">
          $<span id="repayment_amount" style="color: green"></span> druing case
          interest only
        </div>
        <input type="hidden" name="loan_repayment_amount" id="hidden_estimated_repayment"/>
      </div>

      <div class="oan-content-1 row flx align-items-center">
        <div class="col-sm-5 col-md-5">
          Estimated Repayment Insterest + Principal<br /><small>over 10 year period</small>
        </div>
        <div class="col-sm-7 col-md-7">
          $<span id="repayment_amount" style="color: green"></span>
        </div>
        <input type="hidden" name="loan_repayment_amount" id="hidden_estimated_repayment"/>
      </div>

      <div class="loan-content-1 row flx align-items-center">
        <div class="col-sm-5 col-md-5" data-toggle="modal" data-target="#ackAndConsentModal">
          Acknowledgement & Consent
        </div>
        <div class="col-sm-7 col-md-7" data-toggle="modal" data-target="#ackAndConsentModal">
          <div class="flx align-items-end">
              <a href="/downloadPdf/Acknowledgment.pdf" style="text-decoration:none;color:#000;" @click="downloadPdf">
              <div class="file-download-duotone-icon file-download-duotone-3-icon" style="width: 37px; height: 50px; display: inline-block"></div>
              <span class="pl-10">Please select and confirm</span></a>
          </div>
        </div>
      </div>

      <button type="button" style="margin: auto; display: block" class="continue-btn mt-50 mb-30 mt-10" @click.prevent.stop="onContinue('loan-term')">
        <a href="#" class="steps-btn" style="display: block; color: #fff">CONTINUE</a>
      </button>
      <hr style="margin-bottom: calc(10% + 40px); border: none">
    </div>
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    downloadPdf() {
      axios.get("/downloadPdf/Acknowledgment.pdf");
    },
    calculate_repayment(){
      var input_value = parseInt($("#loanamount").val()) || 0;
      var freq = $("[name='loan_repayment_frequency']:checked").val() || "";
      $("#repayment_amount").text(input_value.toLocaleString('en-US'));
    },
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
